import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type CoverageSnapshot } from 'schemas';
import { MEMBER_PLAN_SLICE_NAME } from '../slicesNames';
import * as memberPlanThunks from './memberPlanThunks';
import * as sessionThunks from '../session/sessionThunks';

export interface PlanConfig {
  name: string;
  individualDeductible: number;
  individualOutOfPocketMax: number;
  familyDeductible: number;
  familyOutOfPocketMax: number;
}

export interface MemberPlanState {
  planConfig: PlanConfig | null;
  memberPlan: CoverageSnapshot | null;
  isLoading: boolean;
  isComplete: boolean;
  error: string;
}

export const getInitialState = (): MemberPlanState => ({
  planConfig: null,
  memberPlan: null,
  isLoading: false,
  isComplete: false,
  error: '',
});

const memberPlanSlice = createSlice({
  name: MEMBER_PLAN_SLICE_NAME,
  initialState: getInitialState(),
  extraReducers(builder) {
    builder.addCase(memberPlanThunks.getMemberPlan.pending, (state) => {
      state.isLoading = true;
      state.error = '';
      state.isComplete = false;
    });
    builder.addCase(
      memberPlanThunks.getMemberPlan.fulfilled,
      (state, action: PayloadAction<CoverageSnapshot | null>) => {
        state.isLoading = false;
        state.isComplete = true;
        state.memberPlan = action.payload;
      }
    );
    builder.addCase(memberPlanThunks.getMemberPlan.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error?.message || 'Unknown error fetching the member plan';
      state.isComplete = true;
    });
    builder.addCase(sessionThunks.initializeSession.fulfilled, (state, action) => {
      const { planConfig = {} } = action.payload;
      state.planConfig = planConfig;
    });
  },
  reducers: {},
});

export default memberPlanSlice;
